window.i18n_pt_BR = {
  "general": {
    "accessibility": {
      "skip_to_content": "Pular para o conteúdo",
      "close_modal": "Fechar",
      "link_messages": {
        "new_window": "Abrirá numa nova janela.",
        "external": "Abrirá uma página externa.",
        "new_window_and_external": "Abrirá uma página externa numa nova janela."
      },
      "refresh_page": "Escolher uma seleção resulta em uma atualização de página inteira.",
      "selection_help": "Pressione a tecla de espaço e as teclas de seta para fazer uma seleção.",
      "unit_price_separator": "por",
      "error": "Erro"
    },
    "meta": {
      "tags": "Marcado \"{{ tags }}\"",
      "page": "Página {{ page }}"
    },
    "404": {
      "title": "404 Página não encontrada",
      "subtext": "A página solicitada não existe.",
      "link": "Voltar à loja"
    },
    "pagination": {
      "previous": "Página anterior",
      "next": "Próxima página",
      "current_page": "Página {{ current }} de {{ total }}"
    },
    "password_page": {
      "opening_soon": "Abertura em breve",
      "login_form_heading": "Entre na loja usando a senha",
      "login_form_password_label": "Senha",
      "login_form_password_placeholder": "Sua senha",
      "login_form_submit": "Entrar",
      "signup_form_email_label": "E-mail",
      "signup_form_success": "Nós lhe enviaremos um e-mail logo antes de lançar a loja!",
      "admin_link_html": "Você é o titular da loja? <a href=\"/admin\" class=\"text-link\">Entre aqui</a>",
      "password_link": "Entre usando a senha"
    },
    "social": {
      "share_on_facebook": "Compartilhar",
      "share_on_twitter": "Tuitar",
      "share_on_pinterest": "Pinterest",
      "alt_text": {
        "share_on_facebook": "Compartilhar no Facebook",
        "share_on_twitter": "Tuitar",
        "share_on_pinterest": "Incluir como pin no Pinterest"
      }
    },
    "search": {
      "empty_search_message": "O campo de pesquisa não pode ficar em branco",
      "title": "Pesquise no nosso site",
      "placeholder": "Pesquisar",
      "submit": "Enviar",
      "close": "Fechar pesquisa",
      "heading": {
        "one": "Resultado da pesquisa",
        "other": "Procurar Resultados"
      },
      "search_for": "Pesquisar",
      "loading": "Carregando",
      "clear_search_term": "Limpar termo de pesquisa",
      "number_of_results": "{{ result_number }} de {{ results_count }}",
      "products": "Produtos",
      "number_of_results_found": "{{ results_count }} resultados encontrados",
      "one_result_found": "1 resultado encontrado",
      "no_results": "Tente verificar a ortografia ou usar palavras diferentes.",
      "results_with_count": {
        "one": "{{ count }} resultado para “{{ terms }}”",
        "other": "{{ count }} resultados para “{{ terms }}”"
      }
    },
    "newsletter_form": {
      "newsletter_email": "Assine nossa newsletter",
      "email_placeholder": "E-mail",
      "confirmation": "Obrigado por se inscrever!",
      "submit": "Me inscrever"
    },
    "filters": {
      "show_more": "Exibir mais",
      "show_less": "Exibir menos"
    },
    "payment": {
      "method": "Formas de pagamento"
    },
    "currency": {
      "dropdown_label": "Moeda"
    },
    "language": {
      "dropdown_label": "Idioma"
    }
  },
  "sections": {
    "slideshow": {
      "next_slide": "Próximo slide",
      "previous_slide": "Slide anterior",
      "pause_slideshow": "Pausar apresentação de slides",
      "rotate_slideshow": "Reproduzir apresentação de slides",
      "load_slide": "Abrir slide {{ slide_number }}",
      "navigation_instructions": "Utilize as setas esquerda/direita para navegar pela apresentação de slides, ou deslize para a esquerda/direita se estiver usando um dispositivo móvel"
    },
    "featured_product": {
      "title": "Produto em destaque",
      "gallery_thumbnail_alt": "Carregar imagem no visualizador da galeria, {{ imageAlt }}",
      "video_thumbnail_alt": "Carregar e reproduzir vídeo no visualizador da galeria, {{ imageAlt }}",
      "model_thumbnail_alt": "Carregar modelo 3D no visualizador da galeria, {{ imageAlt }}"
    },
    "map": {
      "address_error": "Não é possível localizar o endereço",
      "address_no_results": "Nenhum resultado para este endereço",
      "address_query_limit_html": "Você excedeu a cota de uso da API do Google. Considere a atualização para um <a href=\"https://developers.google.com/maps/premium/usage-limits\">Plano Premium</a>.",
      "auth_error_html": "Houve um problema ao autenticar sua conta do Google Maps.",
      "section_heading": "Localização"
    },
    "video": {
      "play": "Reproduzir o vídeo {{ video_title }}",
      "pause": "Pausar o vídeo {{ video_title }}",
      "resume": "Continuar o vídeo {{ video_title }}",
      "close": "Fechar vídeo {{ video_title }}"
    },
    "header": {
      "announcement_bar_label": "Comunicado"
    }
  },
  "blogs": {
    "article": {
      "view_all": "Ver tudo",
      "view_all_blogs": "Ver todos os artigos",
      "all_topics": "Todos os tópicos",
      "by_author": "por {{ author }}",
      "posted_in": "Postado em",
      "read_more": "Saiba mais",
      "read_more_title": "Saiba mais: {{ title }}",
      "back_to_blog": "Voltar para {{ title }}",
      "tags": "Tag",
      "article_with_count": {
        "one": "{{ count }} artigo",
        "other": "{{ count }} artigos"
      }
    },
    "comments": {
      "title": "Deixe um comentário",
      "name": "Nome",
      "email": "E-mail",
      "message": "Mensagem",
      "post": "Postar comentário",
      "moderated": "Os comentários precisam ser aprovados antes de serem publicados",
      "success_moderated": "Seu comentário foi publicado. Nós o publicaremos em alguns instantes, já que o nosso blog é moderado.",
      "success": "Seu comentário foi publicado.",
      "unapproved": "O e-mail fornecido não está aprovado para postar comentários.",
      "comments_with_count": {
        "one": "{{ count }} comentário",
        "other": "{{ count }} comentários"
      }
    }
  },
  "cart": {
    "general": {
      "title": "Seu carrinho",
      "note": "Adicione uma observação ao seu pedido",
      "removed_item_html": "<span class=\"cart__removed-product-details\">({{ quantity }}) {{ link }}</span> removido(s) do seu carrinho.",
      "remove": "Remover",
      "subtotal": "Subtotal",
      "savings": "Você está economizando",
      "taxes_and_shipping_at_checkout": "Tributos e frete calculados no checkout",
      "taxes_and_shipping_policy_at_checkout_html": "Tributos e <a href=\"{{ link }}\">frete</a> calculados no checkout",
      "taxes_included_but_shipping_at_checkout": "Imposto incluído e frete calculado no checkout",
      "taxes_included_and_shipping_policy_html": "Taxas incluídas. <a href=\"{{ link }}\">Frete</a> calculado no checkout.",
      "update": "Atualizar",
      "checkout": "Finalizar compra",
      "empty": "Seu carrinho está vazio no momento.",
      "cookies_required": "Habilite os cookies para usar o carrinho de compras",
      "continue_shopping": "Voltar à loja",
      "cart_error": "Houve um erro ao atualizar o seu carrinho. Tente novamente."
    },
    "label": {
      "discounted_total": "Desconto total",
      "product": "Produto",
      "price": "Preço",
      "price_column": "Veja as informações do desconto na coluna Preço.",
      "product_details": "Informações do produto",
      "quantity": "Quantidade",
      "qty": "Qtde",
      "regular_total": "Total regular",
      "remove": "Remover {{ product }}",
      "total": "Total",
      "update": "Atualizar"
    },
    "popup": {
      "added_to_cart": "Acaba de ser adicionado ao seu carrinho",
      "cart_count": {
        "one": "{{ count }} item",
        "other": "{{ count }} itens"
      },
      "product_details": "Informações do produto",
      "quantity": "Qtde",
      "quantity_label": "Quantidade: {{ quantity_count }}"
    }
  },
  "collections": {
    "general": {
      "view_all": "Ver tudo",
      "view_all_label": "Ver todos os produtos da coleção {{ collection_name }}",
      "no_matches": "Desculpe, não há produtos nesta coleção",
      "items_with_count": {
        "one": "{{ count }} produto",
        "other": "{{ count }} produtos"
      },
      "collection_label": "Coleção"
    },
    "catalog": {
      "title": "Catálogo"
    },
    "sorting": {
      "title": "Organizar por"
    },
    "filters": {
      "title_tags": "Filtrar por",
      "all_tags": "Todos os produtos"
    }
  },
  "contact": {
    "form": {
      "name": "Nome",
      "email": "E-mail",
      "phone": "Número de telefone",
      "message": "Mensagem",
      "submit": "Enviar",
      "post_success": "Obrigado por entrar em contato conosco. Retornaremos o mais rápido possível.",
      "error_heading": "Por favor, ajuste o seguinte:"
    }
  },
  "customer": {
    "account": {
      "title": "Minha conta",
      "details": "Informações da conta",
      "view_addresses": "Ver endereços",
      "return": "Retornar às informações da conta"
    },
    "activate_account": {
      "title": "Ativar conta",
      "subtext": "Crie sua senha para ativar sua conta.",
      "password": "Senha",
      "password_confirm": "Confirmar senha",
      "submit": "Ativar conta",
      "cancel": "Recusar convite"
    },
    "addresses": {
      "title": "Seus endereços",
      "default": "Padrão",
      "add_new": "Adicionar um novo endereço",
      "edit_address": "Editar endereço",
      "first_name": "Nome",
      "last_name": "Sobrenome",
      "company": "Empresa",
      "address1": "Endereço",
      "address2": "Casa, apto. etc.",
      "city": "Cidade",
      "country": "País/região",
      "province": "Província/Estado",
      "zip": "CEP",
      "phone": "Telefone",
      "set_default": "Definir como endereço padrão",
      "add": "Adicionar endereço",
      "update": "Atualizar endereço",
      "cancel": "Cancelar",
      "edit": "Editar",
      "delete": "Excluir",
      "delete_confirm": "Tem certeza de que deseja excluir este endereço?"
    },
    "login": {
      "title": "Entrar",
      "email": "E-mail",
      "password": "Senha",
      "forgot_password": "Esqueceu sua senha?",
      "sign_in": "Fazer login",
      "guest_title": "Continuar como convidado",
      "guest_continue": "Continuar"
    },
    "orders": {
      "title": "Histórico de pedidos",
      "order_number": "Pedido",
      "order_number_link": "Pedido número {{ number }}",
      "date": "Data",
      "payment_status": "Status do pagamento",
      "fulfillment_status": "Status de processamento do pedido",
      "total": "Total",
      "none": "Você ainda não fez nenhum pedido."
    },
    "order": {
      "title": "Pedido {{ name }}",
      "date_html": "Efetuado em {{ date }}",
      "cancelled_html": "Pedido cancelado em {{ date }}",
      "cancelled_reason": "Motivo: {{ reason }}",
      "billing_address": "Endereço de faturamento",
      "payment_status": "Status do pagamento",
      "shipping_address": "Endereço de entrega",
      "fulfillment_status": "Status de processamento do pedido",
      "discount": "Desconto",
      "shipping": "Frete",
      "tax": "Tributos",
      "product": "Produto",
      "sku": "SKU",
      "price": "Preço",
      "quantity": "Quantidade",
      "total": "Total",
      "fulfilled_at_html": "Processado em {{ date }}",
      "subtotal": "Subtotal",
      "track_shipment": "Rastrear o pacote"
    },
    "recover_password": {
      "title": "Redefinir sua senha",
      "email": "E-mail",
      "submit": "Enviar",
      "cancel": "Cancelar",
      "subtext": "Nós lhe enviaremos um e-mail para redefinir sua senha.",
      "success": "Nós lhe enviamos um e-mail com um link para atualizar sua senha."
    },
    "reset_password": {
      "title": "Redefinir senha da conta",
      "subtext": "Digite uma nova senha para {{ email }}",
      "password": "Senha",
      "password_confirm": "Confirmar senha",
      "submit": "Redefinir senha"
    },
    "register": {
      "title": "Criar conta",
      "first_name": "Nome",
      "last_name": "Sobrenome",
      "email": "E-mail",
      "password": "Senha",
      "submit": "Criar"
    }
  },
  "homepage": {
    "general": {
      "title": "Página inicial"
    },
    "onboarding": {
      "product_title": "Nome do seu produto",
      "product_description": "Essa área é usada para descrever as informações do seu produto. Conte aos clientes sobre a aparência, textura e estilo de seu produto. Adicione detalhes como cores, materiais utilizados, tamanhos e lugar de fabricação.",
      "collection_title": "Nome da sua coleção",
      "blog_title": "Título de seu post",
      "blog_excerpt": "Sua loja ainda não publicou nenhum post no blog. Um blog pode ser usado para falar sobre lançamentos de novos produtos, dicas ou outras novidades que você quer compartilhar com seus clientes. Confira o blog de e-commerce da Shopify para se inspirar e ver dicas para sua própria loja e blog.",
      "blog_author": "Nome do autor",
      "no_content": "Atualmente, esta seção não possui nenhum conteúdo. Adicione conteúdo a esta seção usando a barra lateral."
    }
  },
  "layout": {
    "navigation": {
      "search": "Pesquisar",
      "expand": "expandir",
      "collapse": "recolher",
      "menu": "Menu"
    },
    "cart": {
      "title": "Carrinho",
      "items_count": {
        "one": "item",
        "other": "itens"
      }
    },
    "customer": {
      "account": "Conta",
      "log_out": "Sair",
      "log_in": "Fazer login",
      "create_account": "Criar conta"
    },
    "footer": {
      "social_platform": "{{ name }} em {{ platform }}"
    }
  },
  "products": {
    "product": {
      "regular_price": "Preço normal",
      "sold_out": "Esgotado",
      "unavailable": "Indisponível",
      "on_sale": "Em promoção",
      "sale_price": "Preço promocional",
      "quantity": "Quantidade",
      "add_to_cart": "Adicionar ao carrinho",
      "loader_label": "Adicionando o produto ao seu carrinho",
      "back_to_collection": "Voltar para {{ title }}",
      "vendor": "Fornecedor",
      "quantity_minimum_message": "Quantidade precisa ser 1 ou mais",
      "include_taxes": "Taxas incluídas.",
      "shipping_policy_html": "<a href=\"{{ link }}\">Frete</a> calculado no checkout.",
      "unit_price_label": "Preço unitário",
      "view_cart": "Ver carrinho",
      "availability": "Disponibilidade",
      "from_lowest_price_html": "de {{ lowest_price }}",
      "view_in_space": "Ver no seu espaço",
      "view_in_space_label": "Ver em seu espaço, carregar item na janela de realidade aumentada"
    }
  },
  "gift_cards": {
    "issued": {
      "title_html": "Aqui está o seu cartão-presente de {{ value }} para {{ shop }}!",
      "subtext": "Seu cartão-presente",
      "gift_card_code": "Código do cartão-presente",
      "disabled": "Desabilitado",
      "expired": "Expirado em {{ expiry }}",
      "active": "Expira em {{ expiry }}",
      "redeem_html": "Para resgatar o seu cartão-presente de {{ value }}, utilize este código no fechamento do pedido",
      "shop_link": "Comece a comprar",
      "print": "Imprimir este cartão-presente",
      "remaining_html": "{{ balance }} restante(s)",
      "add_to_apple_wallet": "Adicionar ao Apple Wallet",
      "qr_image_alt": "código QR - digitalizar para resgatar cartão de presente"
    }
  },
  "store_availability": {
    "general": {
      "view_store_info": "Ver as informações da loja",
      "check_other_stores": "Verificar a disponibilidade em outras lojas",
      "pick_up_available": "Retirada disponível",
      "pick_up_currently_unavailable": "Retirada indisponível no momento",
      "pick_up_available_at_html": "Retirada disponível em <strong>{{ location_name }}</strong>",
      "pick_up_unavailable_at_html": "Retirada em <strong>{{ location_name }}</strong> indisponível no momento"
    }
  },
  "dynosim": {
    "auto": {
      "multiple_sessions_detected": "Múltiplas Sessões Detectadas",
      "your_account_is_active_in_another_window": "Sua conta está ativa em outra janela ou dispositivo. Feche a outra sessão para continuar usando o AlphaX Tuning Sim.",
      "alphax_tuning_simulator": "Simulador de Tuning AlphaX",
      "garage_tuning": "Garagem (Tuning)",
      "dynamometer": "Dinamômetro",
      "drag_strip": "Pista de Arrancada",
      "leaderboards": "Classificações",
      "login": "login",
      "import_tune": "IMPORTAR MAPA",
      "export_tune": "Exportar Mapa",
      "start_engine": "LIGAR MOTOR",
      "rpm": "RPM",
      "147": "14.7",
      "afr": "AFR",
      "status": "Status:",
      "off": "OFF",
      "map": "MAP:",
      "101_kpa": "101 kPa",
      "boost": "Pressão:",
      "00_psi": "0.0 psi",
      "config": "Config:",
      "twin_turbo": "TWIN TURBO",
      "tps": "TPS:",
      "0": "0%",
      "timing": "Ponto:",
      "knk_retard": "Atraso KNK:",
      "knock_count": "Contagem de Detonação:",
      "inj_pw_cyl_1": "Pulso Iny. (Cil 1):",
      "00_ms": "0.0 ms",
      "vvt_intake": "VVT Admissão:",
      "vvt_exhaust": "VVT Escape:",
      "coolant_temp": "Temp. Arrefecimento:",
      "_": "+ / - / *",
      "ethanol": "Etanol:",
      "fuel_rail": "Flauta de Comb.:",
      "_psi": "-- PSI",
      "stft": "STFT:",
      "pump_load": "Carga da Bomba:",
      "battery": "Bateria:",
      "125_v": "12.5 V",
      "max_pedal_tps": "TPS Máximo do Pedal",
      "100": "100%",
      "throttle_hold": "Manter Acelerador",
      "pedal": "PEDAL",
      "ecu_flags": "FLAGS DA ECU:",
      "engine_limits": "Limites do Motor",
      "trigger": "Trigger",
      "adv_uo": "Apenas para usuários avançados!",
      "smart_alternator": "Alternador Inteligente",
      "axis_wizard": "Assistente de Eixos",
      "ve_table": "Tabela VE",
      "target_afr_table": "Tabela AFR Alvo",
      "fuel_settings": "Ajustes de Combustível",
      "flex_fuel": "Flex Fuel",
      "closed_loop_fuel": "Malha Fechada (Comb.)",
      "accel_enrichment": "Enriquecimento Acel.",
      "ignition_advance": "Avanço de Ignição",
      "ignition_settings": "Ajustes de Ignição",
      "knock_control": "Controle de Detonação",
      "vvt_intake_target": "Alvo VVT Admissão",
      "vvt_exhaust_target": "Alvo VVT Escape",
      "vvt_vtec_settings": "Ajustes VVT / VTEC",
      "idle": "Marcha Lenta",
      "cranking": "Partida",
      "upgrades_mods": "Upgrades & Mods",
      "nitrous_system": "Sistema de Nitro",
      "wastegate_duty_table": "Tabela Duty Wastegate",
      "cl_boost_target": "Alvo Pressão (CL)",
      "launch_control": "Controle de Largada",
      "simulation_settings": "Ajustes de Simulação",
      "simple": "SIMPLES",
      "adv": "AVANÇ.",
      "buy_advanced_mode": "Comprar Modo Avançado!",
      "log_off": "SAIR",
      "selection_tools": "Ferramentas de Seleção:",
      "interp_x_row": "Interp X (Linha)",
      "interp_y_col": "Interp Y (Coluna)",
      "interp_2d_area": "Interp 2D (Área)",
      "keys_hinterp_x_vinterp_y_iinterp_2d_gtlt": "Keys: H=Interp X · V=Interp Y · I=Interp 2D · &gt;/&lt;=±1 · +/-/*=math then Enter · Arrows=navigate · Ctrl+C/V=copy/paste · Ctrl+Z/Y=undo/redo",
      "ve_table_load_vs_rpm": "Tabela VE (Carga vs RPM)",
      "higher_numbers_more_fuel_adjust_to_hit_t": "Números maiores = mais combustível. Ajuste para atingir o AFR alvo.",
      "target_afr_table_load_vs_rpm": "Tabela AFR Alvo (Carga vs RPM)",
      "commanded_airfuel_ratio_core_part_of_the": "Relação Ar/Combustível comandada. Parte central da equação Speed Density.",
      "fuel_injector_settings": "Ajustes de Combustível e Injetores",
      "injector_size_ccmin": "Tamanho do Injetor (cc/min)",
      "injector_reference_pressure_kpa": "Pressão de Ref. do Injetor (kPa)",
      "dead_time_ms_by_v": "Tempo Morto (ms por V)",
      "c": "°C",
      "multiplier_at_each_iat_10_no_change_09_1": "Multiplicador para cada IAT. 1.0 = sem mudança.",
      "ect_fuel_enrichment_": "Enriquecimento ECT (×)",
      "fuel_multiplier_on_cold_start_10_no_corr": "Multiplicador de partida a frio. 1.0 = sem correção na temp. de op.",
      "fuel_octane": "Octanagem do Combustível",
      "87_aki_regular": "87 AKI (Comum)",
      "91_aki_premium": "91 AKI (Premium)",
      "93_aki_premium": "93 AKI (Premium+)",
      "100_aki_race_gas": "100 AKI (Gasolina de Corrida)",
      "104_aki_race_gas": "104 AKI (Gasolina de Corrida)",
      "116_aki_methanolrace": "116+ AKI (Metanol/Corrida)",
      "display_afr_as_lambda_3_decimals": "Exibir AFR como Lambda (3 decimais)",
      "enable_fuel_pressure_model": "Habilitar Modelo de Pressão de Comb.",
      "base_fuel_pressure_psi": "Pressão de Comb. Base (PSI)",
      "fuel_system_type": "Tipo de Sistema de Comb.",
      "return_style_rising_rate": "Com Retorno (taxa crescente)",
      "returnless_fixed_pressure": "Sem Retorno (pressão fixa)",
      "return_style_rail_rises_11_with_boost_in": "Com retorno: pressão sobe 1:1 com o boost. Sem retorno: pressão fixa.",
      "apply_settings": "Aplicar Ajustes",
      "ignition_timing_table_load_vs_rpm": "Tabela de Ignição (Carga vs RPM)",
      "degrees_before_top_dead_center_too_much_": "Graus antes do Ponto Morto Superior. Muito avanço causa detonação.",
      "flex_fuel_sensor_simulation": "Simulação de Sensor Flex Fuel",
      "moving_this_slider_simulates_adding_etha": "Mover este controle simula a adição de etanol.",
      "enable_flex_fuel_tuning_populate_flex_ta": "Habilitar Tuning Flex Fuel",
      "ethanol_content_": "Conteúdo de Etanol (%)",
      "apply_content": "Aplicar Conteúdo",
      "flex_fuel_ve_adder_": "Aditivo VE Flex Fuel (%)",
      "blend_curve_0_100_x_base_map_map_vs_rpm": "Curva de Mistura (0-100%) x Mapa Base (MAP vs RPM)",
      "flex_fuel_afr_offset": "Offset AFR Flex Fuel",
      "flex_fuel_timing_adder_deg": "Aditivo Ignição Flex Fuel (deg)",
      "flex_fuel_boost_duty_adder_": "Aditivo Duty Pressão Flex Fuel (%)",
      "blend_curve_0_100_x_base_map_tps_vs_rpm": "Curva de Mistura (0-100%) x Mapa Base (TPS vs RPM)",
      "closed_loop_fuel_stft": "Combustível Malha Fechada (STFT)",
      "enable_closed_loop_correction": "Habilitar Correção de Malha Fechada",
      "deadband_": "Banda Morta (%)",
      "lambda_error_within_this_band_is_ignored": "Erro de Lambda nesta banda é ignorado.",
      "tps_lt_5_rpm_near_idle_target": "(TPS < 5%, RPM perto do alvo de lenta)",
      "time_constant_s": "Constante de Tempo (s)",
      "gain_00833_s": "Gain: 0.0833 /s",
      "min_correction_": "Correção Mín. (%)",
      "max_correction_": "Correção Máx. (%)",
      "part_throttle_cruise": "(meio pedal / cruzeiro)",
      "gain_01250_s": "Gain: 0.1250 /s",
      "tps_gt_90": "(TPS > 90%)",
      "gain_02000_s": "Gain: 0.2000 /s",
      "acceleration_enrichment": "Enriquecimento de Aceleração",
      "corrects_fueling_during_rapid_throttle_o": "Corrige o combustível durante aberturas rápidas de borboleta.",
      "mode": "MODO:",
      "none_disabled": "Nenhum (Desabilitado)",
      "ms_adder": "Aditivo MS",
      "map_prediction": "Predição MAP",
      "accel_time_s": "Tempo Acel. (s)",
      "hard_cutoff_duration_of_enrichment_event": "Hard cutoff duration of enrichment event",
      "decay_rate": "Taxa de Decaimento",
      "ms_mode_mss_middot_map_mode_blends": "MS mode: ms/s &middot; MAP mode: blend/s",
      "ms_adder_dtps_s_vs_rpm_rarr_ms": "Aditivo MS (dTPS %/s vs RPM → ms)",
      "extra_injection_ms_on_tip_in_y_tps_rate_": "Injeção extra em ms na pisada.",
      "map_prediction_tps_vs_rpm_rarr_kpa": "Predição MAP (TPS % vs RPM → kPa)",
      "predicted_map_for_veafrtiming_lookups_du": "Predicted MAP for VE/AFR/timing lookups during tip-in. Y = TPS %, X = RPM.",
      "ignition_system_mode": "Modo do Sistema de Ignição",
      "sets_coil_topology_recharge_time_and_mel": "Sets coil topology, recharge time, and melt behavior.",
      "distributor_single_coil": "Distribuidor (Bobina Única)",
      "wasted_spark_n2_coils": "Centelha Perdida (N/2 Bobinas)",
      "fully_sequential_cop": "Sequencial / COP",
      "spark_plug_gap_inches": "Gap das Velas (polegadas)",
      "wider_gap_needs_more_dwell_to_fire_under": "Wider gap = needs more dwell to fire. Under boost, effective gap shrinks 0.005&quot; per 10 psi — tighter gaps recommended on boosted builds.",
      "degrees_of_retard_at_each_iat_0_no_retar": "Graus de atraso por IAT. 0 = sem atraso.",
      "coil_dwell_time_ms_by_battery_v": "Dwell da Bobina (ms por V da Bateria)",
      "coil_charge_time_low_voltage_during_cran": "Coil charge time. Low voltage during cranking may cause weak spark.",
      "knock_sensor_spectrogram": "Espectrograma do Sensor de Detonação",
      "pause": "PAUSAR",
      "cyan_noise_level_nbspnbsp_red_dashed_thr": "Ciano = nível de ruído | Vermelho tracejado = limite",
      "_25s": "-2.5s",
      "now": "Agora",
      "knock_threshold_db_vs_rpm": "Limite de Detonação (dB vs RPM)",
      "noise_level_above_which_a_knock_event_tr": "Noise level above which a knock event triggers retard. At idle background noise is ~-26 dB; knock spikes to ~-2 dB.\n                                Set each cell just below the lowest knock spike at that RPM. Default -10 dB is a good starting point at lower RPM.\n                                At high RPM you may need to lower to -15 dB or below to avoid false positives.",
      "control_parameters": "Parâmetros de Controle",
      "enable_knock_control": "Habilitar Controle de Detonação",
      "complete_knock_frequency_calibration_bel": "Complete Knock Frequency Calibration below to unlock.",
      "attack_degevent": "Ataque (deg/evento)",
      "degrees_removed_per_knock_detection_0510": "Degrees removed per knock detection. 0.5–10°",
      "max_retard_deg": "Atraso Máx. (deg)",
      "maximum_accumulated_retard_120": "Maximum accumulated retard. 1–20°",
      "recovery_rate_degrev": "Taxa de Recuperação (deg/rev)",
      "degrees_recovered_per_engine_revolution_": "Degrees recovered per engine revolution. 0.1–2.0",
      "min_tps_to_engage_": "TPS Mín. para Ativar (%)",
      "suppresses_retard_below_this_throttle_po": "Suppresses retard below this throttle position. Prevents false triggers on decel pops.",
      "min_map_to_engage_kpa": "MAP Mín. para Ativar (kPa)",
      "suppresses_retard_below_this_manifold_pr": "Suppresses retard below this manifold pressure. 60 kPa ≈ light cruise.",
      "knock_control_frequency_calibration_mode": "Modo de Calibração de Freq. de Detonação",
      "enter_calibration_mode": "Entrar no Modo Calibração",
      "identify_the_engines_natural_knock_reson": "Identifique a frequência de ressonância natural do motor.",
      "formula_f_573_boremm_nbspnbsp_81_mm_bore": "Formula: f ≈ 573 ÷ bore_mm &nbsp;|&nbsp; 81 mm bore ≈ 7.07 kHz &nbsp;|&nbsp; 102 mm bore ≈ 5.61 kHz",
      "20k": "20k",
      "15k": "15k",
      "10k": "10k",
      "5k": "5k",
      "_5_seconds_ago": "← 5 seconds ago",
      "now_": "Now →",
      "center_freq_khz": "Freq. Central (kHz)",
      "khz": "kHz",
      "temp_timing_adder": "Aditivo de Ponto Temp.",
      "_for": "° for",
      "s": "s",
      "apply": "Aplicar",
      "confirm_calibration": "Confirmar Calibração",
      "recalibrate": "Recalibrar",
      "nitrous_oxide_system": "Sistema de Óxido Nitroso",
      "upgrades_amp_mods": "Upgrades & Mods",
      "n2o_jet_size_thousandths_in": "Gicleur de N2O (milésimos de pol.)",
      "estimated_power": "Potência Estimada",
      "_337_hp": "≈ 33.7 HP",
      "fuel_jet_size_thousandths_in": "Gicleur de Comb. (milésimos de pol.)",
      "wet_shot_fuel_solenoid_handles_base_enri": "Wet shot: fuel solenoid handles base enrichment. ECU VE comp adds on top.",
      "activation_mode": "Modo de Ativação",
      "button_switch": "Botão / Chave",
      "ecu_control": "Controle da ECU",
      "ecu_control_parameters": "Parâmetros de Controle da ECU",
      "min_tps_": "TPS Mín. (%)",
      "min_rpm": "RPM Mín.",
      "max_rpm": "RPM Máx.",
      "max_map_kpa": "MAP Máx. (kPa)",
      "afr_safety_cut_lean": "Corte de Seg. AFR (pobre)",
      "fuel_ve_comp_": "Comp. VE de Comb. (%)",
      "extra_fuel_when_n2o_is_active_dry_primar": "Extra fuel when N2O is active. Dry = primary comp. Wet = supplement on top of fuel solenoid.",
      "timing_retard_": "Atraso de Ignição (°)",
      "degrees_pulled_from_commanded_timing_whe": "Degrees pulled from commanded timing when N2O is active.",
      "apply_nitrous_settings": "Aplicar Ajustes de Nitro",
      "vvt_intake_advance_target_load_vs_rpm": "Alvo Avanço VVT Admissão (Carga vs RPM)",
      "positive_degrees_of_intake_cam_advance_i": "Positive degrees of intake cam advance. Interpolates absolute \"In_X\" engine maps.",
      "vvt_exhaust_retard_target_load_vs_rpm": "Alvo Atraso VVT Escape (Carga vs RPM)",
      "negative_degrees_of_exhaust_cam_retard_i": "Negative degrees of exhaust cam retard. Interpolates absolute \"Ex_X\" engine maps.",
      "variable_valve_lift_vvl_vtec": "Levantamento de Válvula Variável (VVL / VTEC)",
      "vvl_high_cam_switch_rpm": "Troca VVL / Came Alta (RPM)",
      "vvl_high_cam_min_tps_": "TPS Mín. Came Alta VVL (%)",
      "vvl_fuel_adder_ve_": "Aditivo Comb. VVL (VE %)",
      "vvl_timing_adder_": "Aditivo Ponto VVL (°)",
      "continuous_vvt_phase_angles_are_controll": "Continuous VVT phase angles are controlled via the 9x9 tables.",
      "closed_loop_pid_control": "Controle PID Malha Fechada",
      "enable_closed_loop_pid_control": "Habilitar Controle PID Malha Fechada",
      "proportional_kp": "Proporcional (Kp)",
      "integral_ki": "Integral (Ki)",
      "derivative_kd": "Derivativo (Kd)",
      "higher_kp_faster_response_ki_eliminates_": "Higher Kp = faster response. Ki eliminates steady-state error. Kd damps overshoot. Live display shows actual° / target° when enabled.",
      "wastegate_duty_table_tps_vs_rpm": "Tabela Duty Wastegate (TPS vs RPM)",
      "commanded_wastegate_solenoid_duty_cycle_": "Commanded wastegate solenoid duty cycle (0–100%). Higher duty = more boost. Requires a turbocharger mod installed. In Closed-Loop Boost mode this table acts as the feed-forward base; the PID trims on top.",
      "cl_boost_target_table_tps_vs_rpm": "Tabela Alvo Pressão Malha Fechada (TPS vs RPM)",
      "target_boost_pressure_in_psi_used_when_c": "Target boost pressure in PSI. Used when Closed-Loop Boost is enabled in Mod Settings. 0 = match wastegate spring pressure. The WG Duty table is the feed-forward base; the PID adjusts duty to hit this target.",
      "rev_limit_rpm": "Limitador (RPM)",
      "rev_limit_hysteresis_rpm": "Histerese do Limitador (RPM)",
      "fuel_cut": "Corte de Comb.",
      "spark_cut": "Corte de Ignição",
      "enable_decel_fuel_cut": "Corte em Desaceleração",
      "cut_delay_sec": "Atraso do Corte (Seg)",
      "boost_protection": "Proteção de Pressão",
      "boost_cut_psi": "Corte de Pressão (psi)",
      "hysteresis_psi": "Histerese (psi)",
      "trigger_calibration": "Calibração de Trigger",
      "timing_light_mode": "Modo Ponto com Estrobo",
      "simulates_a_timing_light_check_engine_st": "Simulates a timing light check. Engine start is disabled while active.",
      "must_match_engine_base_offset_affects_ti": "must match engine base offset — affects timing at all times",
      "fixed_timing_ecu_commanded_045_btdc": "Fixed Timing — ECU commanded (0–45° BTDC)",
      "enable_smart_alternator": "Habilitar Alternador Inteligente",
      "alt_pressure_rises_05_v_per_1000_rpm_pid": "Alt pressure rises +0.5 V per 1000 RPM. PID controls duty to hold target voltage.",
      "p_gain": "Ganho P",
      "i_gain": "Ganho I",
      "d_gain": "Ganho D",
      "alternator_duty": "Duty do Alternador:",
      "na": "N/A",
      "axis_setup_wizard": "Assistente de Config. de Eixos",
      "sets_the_16_point_rpm_and_map_load_axes_": "Sets the 16-point RPM and MAP (load) axes for the VE, AFR, and Timing tables. WG Duty table columns (RPM) also update. The WG Duty row axis (TPS) is unaffected.",
      "base_rpm": "RPM Base",
      "base_kpa_min_load": "kPa Base (carga mín.)",
      "max_kpa": "kPa Máx.",
      "apply_axis_wizard": "Aplicar Assistente",
      "reset_to_default": "Resetar para Padrão",
      "note_existing_tune_values_are_interpolat": "Note: existing tune values are interpolated/extrapolated onto the new axes. Values beyond your current range are linearly extrapolated from the edge trend.",
      "idle_settings": "Ajustes de Marcha Lenta",
      "maximum_idle_tps": "TPS Máximo em Lenta",
      "actual_throttle_when_duty_curve_reads_10": "Actual throttle % when duty curve reads 100%.",
      "idle_control_rpm_upper_limit": "Limite Superior RPM Controle Lenta",
      "idle_control_disengages_above_target_rpm": "Idle control disengages above Target RPM + this value.",
      "target_idle_rpm_vs_coolant_temp": "Alvo RPM Lenta vs Temp. Arref.",
      "idle_rpm_target_by_coolant_temperature_r": "Idle RPM target by coolant temperature. Runs higher when cold.",
      "idle_duty_vs_coolant_temp_": "Duty Lenta vs Temp. Arref. (%)",
      "_of_maximum_idle_tps_to_command_at_each_": "% of Maximum Idle TPS% to command at each coolant temperature.",
      "closed_loop_idle_ignition": "Ignição em Lenta Malha Fechada",
      "uses_ignition_timing_to_maintain_target_": "Uses ignition timing to maintain target idle RPM for faster corrections.",
      "p": "P",
      "i": "I",
      "d": "D",
      "cranking_starting": "Partida",
      "base_ve": "VE Base",
      "max_crank_rpm": "RPM Máx. Partida",
      "decay_s": "Decaimento (s)",
      "crank_time_s": "Tempo de Partida (s)",
      "cranking_idle_air_duty_vs_coolant_temp_": "Duty Ar Partida vs Temp. Arref. (%)",
      "throttle_position_air_during_cranking_hi": "Throttle position (air) during cranking. Higher when cold to overcome friction.",
      "post_crank_enrichment_vs_coolant_temp_ve": "Enriquecimento Pós-Partida (×VE)",
      "fuel_multiplier_applied_immediately_afte": "Fuel multiplier applied immediately after cranking ends. 1.0 = no enrichment.",
      "post_crank_decay_cycles": "Ciclos Decaimento Pós-Partida",
      "engine_cycles_720_each_for_enrichment_to": "Engine cycles (720° each) for enrichment to decay from curve value to 1.0×.",
      "vehicle_upgrades": "Upgrades do Veículo",
      "export_mod_list": "EXPORTAR LISTA DE MODS",
      "import_mod_list": "IMPORTAR LISTA DE MODS",
      "mod_collection": "Coleção de Mods",
      "tuner_warning_extreme_mods_like_heavy_ca": "TUNER WARNING: Extreme mods like heavy cams will increase idle vacuum penalty (raises base MAP), which can stall your engine! You will need to tune your low-RPM fuel/timing and raise target idle RPM to compensate.",
      "launch_control_two_step": "Controle de Largada / Two-Step",
      "enable_launch_control": "Habilitar Controle de Largada",
      "launch_rpm": "RPM de Largada",
      "hysteresis_rpm": "Histerese (RPM)",
      "window_size_rpm": "Tamanho da Janela (RPM)",
      "cut_type": "Tipo de Corte",
      "ignition_cut": "Corte de Ignição",
      "both_hard_cut": "Ambos (Corte Brusco)",
      "window_start_timing_deg": "Início da Janela de Ponto (deg)",
      "limit_timing_deg_absolute": "Limite de Ponto (deg absoluto)",
      "fuel_adder_afr_": "Aditivo Comb. (AFR %)",
      "activate_two_step_mode_switch": "Ativar Chave do Modo Two-Step",
      "test_your_launch_settings_in_the_garage_": "Test your launch settings in the garage. When active, the engine will limit to Launch RPM at full throttle even in Neutral.",
      "ambient_conditions_used_as_the_baseline_": "Ambient conditions used as the baseline for all simulations — dyno pulls, drag runs, and the garage physics loop.",
      "unit_system": "Sistema de Unidades",
      "affects_all_displayed_temperatures_press": "Affects all displayed temperatures, pressures, and speed. AFR/Lambda can be toggled separately by clicking the gauge.",
      "pressure_display_mode": "Modo de Exibição de Pressão",
      "absolute": "Absoluta",
      "gauge": "Relativa",
      "switches_pressure_on_y_axes_and_gauges": "Alterna a pressão nos eixos Y e medidores entre pressão absoluta e relativa. Os cálculos internos sempre usam kPa absoluto.",
      "ambient_temperature_f": "Temp. Ambiente (°F)",
      "ambient_temperature_c": "Temp. Ambiente (°C)",
      "sets_base_iat_for_the_physics_loop": "Sets base IAT for the physics loop.",
      "barometric_pressure_kpa": "Pressão Barométrica (kPa)",
      "affects_map_ceiling_and_airmass_scaling_": "Affects MAP ceiling and airmass scaling (altitude).",
      "relative_humidity_": "Umidade Relativa (%)",
      "used_for_dyno_correction_factor_sae_std": "Used for dyno correction factor (SAE / STD).",
      "coolant_temperature_simulation": "Simulação de Temp. Arref.",
      "enable_ect_simulation": "Habilitar Simulação ECT",
      "when_enabled_engine_starts_cold_at_ambie": "Quando ativado, o motor parte frio na temperatura ambiente e aquece até 90 °C. Desativado = ECT fixo em 90 °C.",
      "o2_sensor_simulation": "Simulação de Sensor O2",
      "enable_o2_transport_delay_amp_combustion": "Habilitar Retardo de Transporte O2 e Ruído de Combustão",
      "adds_exhaust_transport_delay_to_afr_disp": "Adiciona retardo de transporte de escape à leitura de AFR (300ms em marcha lenta, 0ms a 3500 RPM) e variância de combustão de ±3% na física em baixas rotações.",
      "starter_mode": "Modo de Partida",
      "hold_to_engage_hold_the_button_while_the": "Hold to Engage: hold the button while the starter cranks; release after engine fires.",
      "knock_indicator": "Indicador de Detonação",
      "show_knock_event_indicator_overlay": "Exibir indicador de detonação",
      "floating_counter_shown_in_all_views_when": "Contador flutuante exibido em todas as visualizações quando o motor está detonando. No Modo Avançado, use a aba Controle de Detonação.",
      "transmission_selection": "Seleção de Transmissão",
      "export": "EXPORTAR",
      "custom_ratios": "Relações Custom",
      "final_drive_ratio": "RELAÇÃO DE DIFERENCIAL",
      "gear_1": "MARCHA 1",
      "gear_2": "MARCHA 2",
      "gear_3": "MARCHA 3",
      "gear_4": "MARCHA 4",
      "gear_5": "MARCHA 5",
      "gear_6": "MARCHA 6",
      "gear_7": "MARCHA 7",
      "gear_8": "MARCHA 8",
      "gear_9": "MARCHA 9",
      "gear_10": "MARCHA 10",
      "set_ratio_to_0_to_disable_a_gear": "Set ratio to 0 to disable a gear.",
      "apply_simulation_settings": "Aplicar Ajustes de Simulação",
      "virtual_dynamometer": "Dinamômetro Virtual",
      "loads_the_engine_dynamically_to_perform_": "Loads the engine dynamically to perform a real-time full-throttle sweep from start RPM to redline.",
      "auto_log_off": "AUTO-LOG OFF",
      "set_as_reference": "DEFINIR COMO REFERÊNCIA",
      "hold_n2o": "SEGURAR — N2O",
      "smoothing": "SUAVIZAÇÃO:",
      "0_raw": "0 (Bruto)",
      "5_max": "5 (Máx.)",
      "correction": "CORREÇÃO:",
      "none": "Nenhuma",
      "sae": "SAE",
      "std": "STD",
      "load_dyno": "Carregar Dinamômetro",
      "rpm_lock": "Travar RPM",
      "dynojet": "Dynojet",
      "rpms": "RPM/S:",
      "target_rpm": "RPM ALVO:",
      "afr_guideline": "GUIA AFR:",
      "start_rpm": "RPM INICIAL:",
      "ambient_conditions_advanced_simulation_s": "Ambient conditions: Advanced → Simulation Settings",
      "leaderboard_display_name": "Nome de Exibição",
      "submit_to_leaderboard": "Enviar para Classificação",
      "clutch_0": "EMBREAGEM: 0%",
      "run": "RUN",
      "launch": "LARGADA",
      "60ft": "60ft",
      "330ft": "330ft",
      "18_mile": "1/8 Milha",
      "1000ft": "1000ft",
      "14_mile": "1/4 Milha",
      "reaction_time": "Tempo de Reação",
      "9872_check_run_category": "&#9872; Check Run Category",
      "sim_config": "Config Sim",
      "weight_lbs": "Peso (lbs)",
      "shift_rpm": "RPM de Troca",
      "shift_delay_s": "Atraso de Troca (s)",
      "tires": "Pneus",
      "economy": "Econômico",
      "street": "Rua",
      "summer": "Verão",
      "drag_radials": "Drag Radials",
      "drag_slicks": "Slicks",
      "clutch_slip_s": "Deslizamento Emb. (s)",
      "lb_class": "Classe LB",
      "run_controls": "Controles de Run",
      "start_1x": "INICIAR (1x)",
      "ff_3x": "FF (3x)",
      "instant": "INSTANTÂNEO",
      "shift_up": "MARCHA ACIMA",
      "abort": "ABORTAR",
      "n2o": "N2O",
      "manual_mode": "Modo Manual",
      "no_shift_on_slip": "Sem Troca ao Patinar",
      "auto_log": "Auto-Log",
      "hold_cspace_on_line_release_c_to_launch_": "Hold C+SPACE on line → release C to launch &nbsp;|&nbsp; SPACE=throttle &nbsp;C=clutch &nbsp;S=shift↑ &nbsp;X=shift↓",
      "requirement": "Requisito:",
      "logged_in": "logado",
      "advanced_mode": "Modo Avançado",
      "default_vehicle_weight": "Peso Padrão do Veículo",
      "01s_shift_delay": "0.1s Atraso de Troca",
      "engine": "Motor",
      "category": "Categoria",
      "stock_economy": "Original — Econômico",
      "stock_street": "Original — Rua",
      "stock_summer": "Original — Verão",
      "stock_drag_radials": "Original — Drag Radials",
      "stock_drag_slicks": "Original — Slicks",
      "mod_na_economy": "Prep. N/A — Econômico",
      "mod_na_street": "Prep. N/A — Rua",
      "mod_na_summer": "Prep. N/A — Verão",
      "mod_na_drag_radials": "Prep. N/A — Drag Radials",
      "mod_na_drag_slicks": "Prep. N/A — Slicks",
      "power_adder_economy": "Sobrealimentado — Econômico",
      "power_adder_street": "Sobrealimentado — Rua",
      "power_adder_summer": "Sobrealimentado — Verão",
      "power_adder_drag_radials": "Sobrealimentado — Drag Radials",
      "power_adder_drag_slicks": "Sobrealimentado — Slicks",
      "super_pa_economy": "Super PA — Econômico",
      "super_pa_street": "Super PA — Rua",
      "super_pa_summer": "Super PA — Verão",
      "super_pa_drag_radials": "Super PA — Drag Radials",
      "super_pa_drag_slicks": "Super PA — Slicks",
      "search": "Pesquisar",
      "knock_detected": "Detonação Detectada",
      "0_events": "0 eventos",
      "v001": "v0.0.1",
      "1_2": "1 / 2",
      "times": "×",
      "simple_mode_vs_advanced_mode": "Modo Simples vs Avançado",
      "free": "(Grátis)",
      "purchased": "(Comprado)",
      "click_here_to_get_advanced_mode_": "Clique aqui para o Modo Avançado →",
      "extra_engines_amp_mods": "Motores & Mods Extras",
      "click_here_to_browse_engines_": "Clique aqui para ver Motores →",
      "click_here_to_browse_mods_": "Clique aqui para ver Mods →",
      "128274_log_in_to_access_your_purchases": "&#128274; Log In to Access Your Purchases",
      "alphax_account": "Conta AlphaX",
      "alphaxprcom": "alphaxpr.com",
      "controls": "Controles",
      "space": "Espaço",
      "click_drag": "Clique / Arraste",
      "click_cell": "Clique na célula",
      "ctrlz_y": "Ctrl+Z / Y",
      "table_keyboard_shortcuts": "Atalhos de Teclado da Tabela",
      "arrows": "Setas",
      "gt_lt": "&gt; / &lt;",
      "h": "H",
      "v": "V",
      "ctrlc_v": "Ctrl+C / V",
      "datalogging": "Datalogging",
      "basic_tuning_tips": "Dicas Básicas de Tuning",
      "ignition_timing": "Ponto de Ignição",
      "target_afr": "AFR Alvo",
      "map_axis": "Eixo MAP",
      "_back": "← Voltar",
      "controls_": "Controles →",
      "got_it_": "Entendido! ✓",
      "run_category_check": "Run Category Check",
      "close": "Fechar",
      "save_your_tune": "Salvar Mapa",
      "you_have_unsaved_tuning_changes": "Você tem alterações não salvas.",
      "export_your_tune_before_closing_so_you_c": "Export your tune before closing so you can reload it later.",
      "dismiss": "Descartar",
      "keep_adjusting": "Continuar Ajustando",
      "timing_is_correct_": "Ponto está Correto ✓",
      "commanded_wastegate_solenoid_duty_cycle": "Commanded wastegate solenoid duty cycle (0–100%). Higher duty = more boost. Requires a turbocharger mod installed. In Closed-Loop Boost mode this table acts as the feed-forward base; the PID trims on top.",
      "integrates_the_lambda_error_between_actu": "Integrates the lambda error between actual and target AFR each frame and applies a Short-Term Fuel Trim multiplier to correct fueling. Uses your Target AFR table as the setpoint. The integrator gain is",
      "dry_shot_switch_mode_no_ecu_compensation": "Dry shot, switch mode: no ECU compensation is applied. Bake your fuel and timing corrections directly into your VE and timing maps.",
      "sets_the_16_point_rpm_and_map_load_axes": "Sets the 16-point RPM and MAP (load) axes for the VE, AFR, and Timing tables. WG Duty table columns (RPM) also update. The WG Duty row axis (TPS) is unaffected.",
      "keys_hinterp_x_vinterp_y_iinterp_2d_1_ma": "Keys: H=Interp X · V=Interp Y · I=Interp 2D · &gt;/&lt;=±1 · +/-/*=math then Enter · Arrows=navigate · Ctrl+C/V=copy/paste · Ctrl+Z/Y=undo/redo",
      "higher_kp_faster_response_ki_eliminates": "Higher Kp = faster response. Ki eliminates steady-state error. Kd damps overshoot. Live display shows actual° / target° when enabled.",
      "formula_f_573_boremm_81_mm_bore_707_khz": "Formula: f ≈ 573 ÷ bore_mm &nbsp;|&nbsp; 81 mm bore ≈ 7.07 kHz &nbsp;|&nbsp; 102 mm bore ≈ 5.61 kHz",
      "test_your_launch_settings_in_the_garage": "Test your launch settings in the garage. When active, the engine will limit to Launch RPM at full throttle even in Neutral.",
      "hold_cspace_on_line_release_c_to_launch": "Hold C+SPACE on line → release C to launch &nbsp;|&nbsp; SPACE=throttle &nbsp;C=clutch &nbsp;S=shift↑ &nbsp;X=shift↓",
      "ambient_conditions_used_as_the_baseline": "Ambient conditions used as the baseline for all simulations — dyno pulls, drag runs, and the garage physics loop.",
      "mods_include_turbochargers_camshafts_coo": "Mods include turbochargers, camshafts, cooling upgrades, and more — each with real physics effects.",
      "loads_the_engine_dynamically_to_perform": "Loads the engine dynamically to perform a real-time full-throttle sweep from start RPM to redline.",
      "each_engine_has_its_own_power_curve_knoc": "Each engine has its own power curve, knock limits, compression ratio, and tuning maps.",
      "trigger_angle_offset_ecu_360360": "Trigger Angle Offset — ECU (-360–360°)",
      "55_sub_axes_derived_from_the_main_rpm_an": "5×5 sub-axes derived from the main RPM and MAP axes. Scales with the Axis Wizard.",
      "advanced_mode_activates_automatically_wh": "Advanced Mode activates automatically when your purchase is detected at login.",
      "trigger_offset_matches_engine_base_the_t": "Trigger offset matches engine base — the timing mark is perfectly aligned.",
      "inj_mismatch": "Injector size mismatch — check Fuel Settings matches installed injectors",
      "uses_ignition_timing_to_maintain_target": "Uses ignition timing to maintain target idle RPM for faster corrections.",
      "on_the_store_for_the_simulator_to_detect": "on the store for the simulator to detect your purchases and unlock them.",
      "engine_load_in_kpa_higher_more_load_mor": "— engine load in kPa. Higher = more load = more fuel &amp; timing needed",
      "if_you_purchased_something_and_dont_see": "If you purchased something and don't see it, log in to your account on",
      "cyan_noise_level_red_dashed_threshold_at": "Cyan = noise level &nbsp;|&nbsp; Red dashed = threshold at current RPM",
      "torque_bonus_0_at_145_v_3_at_125_v_reduc": "Torque bonus: 0% at 14.5 V → +3% at 12.5 V (reduced alternator drag).",
      "extra_injection_ms_on_tip_in_y_tps_rate": "Extra injection ms on tip-in. Y = TPS rate of change (%/s), X = RPM.",
      "your_purchased_engines_mods_and_advanced": "Your purchased engines, mods, and Advanced Mode are tied to your",
      "logs_include_rpm_map_afr_timing_ve_torqu": "Logs include RPM, MAP, AFR, timing, VE, torque, boost, and more",
      "advance_for_power_but_watch_for_knock_t": "— advance for power, but watch for knock. Typical MBT is 25–35°",
      "degrees_before_top_dead_center_too_much": "Degrees Before Top Dead Center. Too much advance causes knock.",
      "of_maximum_idle_tps_to_command_at_each": "% of Maximum Idle TPS% to command at each coolant temperature.",
      "richer_11121_under_boostwot_stoich_1471": "— richer (11–12:1) under boost/WOT, stoich (14.7:1) at cruise",
      "controls_fuel_delivery_aim_for_1471_afr": "— controls fuel delivery. Aim for ~14.7:1 AFR at cruise",
      "to_submit_runs_must_use": "to submit. \n                            Runs must use",
      "flood_hint": "Hold throttle to floor while cranking to clear flood",
      "affects_map_ceiling_and_airmass_scaling": "Affects MAP ceiling and airmass scaling (altitude).",
      "select_an_engine_and_category_to_view_le": "Select an engine and category to view leaderboards.",
      "degrees_recovered_per_engine_revolution": "Degrees recovered per engine revolution. 0.1–2.0",
      "enable_o2_transport_delay_combustion_noi": "Enable O2 Transport Delay &amp; Combustion Noise",
      "focus_math_input_type_value_enter_to_ap": "— Focus math input → type value → Enter to apply",
      "start_dyno_pull": "START DYNO PULL",
      "drag_strip_leaderboards": "Drag Strip Leaderboards",
      "copy_paste_selection_as_spreadsheet_dat": "— Copy / paste selection as spreadsheet data",
      "to_start_recording_stops_and_exports_a_c": "to start recording — stops and exports a CSV",
      "10003_ve_timing_target_afr_tables": "&#10003; VE, Timing &amp; Target AFR tables",
      "10003_flex_fuel_tables_e85_physics": "&#10003; Flex Fuel tables &amp; E85 physics",
      "interpolate_horizontally_across_selecti": "— Interpolate horizontally across selection",
      "cranking_idle_air_duty_vs_coolant_temp": "Cranking Idle Air Duty vs Coolant Temp (%)",
      "interpolate_vertically_across_selection": "— Interpolate vertically across selection",
      "available_in_garage_dyno_and_drag_modes": "Available in Garage, Dyno, and Drag modes",
      "ms_mode_mss_map_mode_blends": "MS mode: ms/s &middot; MAP mode: blend/s",
      "map_prediction_tps_vs_rpm_kpa": "MAP Prediction (TPS % vs RPM &rarr; kPa)",
      "10003_engine_damage_failure_rng": "&#10003; Engine damage &amp; failure RNG",
      "timing_is_correct": "Timing is Correct ✓",
      "imperial_f_psi_mph": "Imperial (°F &middot; PSI &middot; MPH)",
      "move_selection_hold_shift_to_extend": "— Move selection (hold Shift to extend)",
      "interpolate_2d_entire_selected_area": "— Interpolate 2D (entire selected area)",
      "select_a_dry_or_wet_shot_system_under": "Select a Dry or Wet Shot System under",
      "10003_launch_control_two_step": "&#10003; Launch control &amp; two-step",
      "add_subtract_1_from_selected_cells": "— Add / subtract 1 from selected cells",
      "target_voltage_v_rpm_vs_map_kpa": "Target Voltage (V) — RPM vs MAP (kPa)",
      "to_get_them": "to get them!",
      "metric_c_kpa_kph": "Metric (°C &middot; kPa &middot; KPH)",
      "10003_knock_detection_retard": "&#10003; Knock detection &amp; retard",
      "ms_adder_dtps_s_vs_rpm_ms": "MS Adder (dTPS %/s vs RPM &rarr; ms)",
      "to_qualify": "to qualify.",
      "10003_everything_in_simple_plus": "&#10003; Everything in Simple, plus:",
      "10003_accel_enrichment_ms_map": "&#10003; Accel enrichment (ms / MAP)",
      "tps_5_rpm_near_idle_target": "(TPS &lt; 5%, RPM near idle target)",
      "10003_dyno_drag_simulation": "&#10003; Dyno &amp; Drag simulation",
      "10003_coil_dwell_misfire_physics": "&#10003; Coil dwell misfire physics",
      "10003_vvt_vvl_cam_control": "&#10003; VVT &amp; VVL cam control",
      "10003_closed_loop_boost_control": "&#10003; Closed-loop boost control",
      "calibrated_center_frequency": "✓ Calibrated — center frequency:",
      "need_some_mods_head_over_to_the": "Need some mods? Head over to the",
      "10003_datalogging_csv_export": "&#10003; Datalogging (CSV export)",
      "10003_o2_sensor_delay_modeling": "&#10003; O2 sensor delay modeling",
      "10003_drag_racing_leaderboards": "&#10003; Drag racing leaderboards",
      "click_here_to_get_advanced_mode": "Click Here to get Advanced Mode →",
      "dont_show_again": "Don't show again",
      "map_load_axis_16_points_kpa": "MAP / Load Axis (16 points, kPa)",
      "flex_fuel_boost_duty_adder": "Flex Fuel Boost Duty Adder (%)",
      "10003_basic_closed_loop_afr": "&#10003; Basic closed-loop AFR",
      "click_here_to_browse_engines": "Click Here to browse Engines →",
      "idle_duty_vs_coolant_temp": "Idle Duty vs Coolant Temp (%)",
      "10003_tune_import_export": "&#10003; Tune import / export",
      "10003_smart_alternator_pid": "&#10003; Smart alternator PID",
      "no_nitrous_system_installed": "No nitrous system installed.",
      "10003_fuel_pressure_model": "&#10003; Fuel pressure model",
      "click_here_to_browse_mods": "Click Here to browse Mods →",
      "edit_a_tuning_table_value": "— Edit a tuning table value",
      "iat_timing_retard_by_iat": "IAT Timing Retard (by IAT",
      "vvl_high_cam_min_tps": "VVL / High Cam Min TPS (%)",
      "10003_idle_ignition_pid": "&#10003; Idle ignition PID",
      "extra_engines_mods": "Extra Engines &amp; Mods",
      "then_reload_this_page": ", then reload this page.",
      "hold_to_rev_the_engine": "— Hold to rev the engine",
      "ect_fuel_enrichment": "ECT Fuel Enrichment (×)",
      "10003_decel_fuel_cut": "&#10003; Decel fuel cut",
      "flex_fuel_ve_adder": "Flex Fuel VE Adder (%)",
      "iat_ve_comp_by_iat": "IAT VE Comp% (by IAT",
      "min_tps_to_engage": "Min TPS to Engage (%)",
      "vvl_fuel_adder_ve": "VVL Fuel Adder (VE %)",
      "voltage_regulator_pid": "Voltage Regulator PID",
      "relative_humidity": "Relative Humidity (%)",
      "modified_violations": "Modified+ violations:",
      "vvl_timing_adder": "VVL Timing Adder (°)",
      "rpm_axis_16_points": "RPM Axis (16 points)",
      "active_session_id": "Active Session ID:",
      "ethanol_content": "Ethanol Content (%)",
      "min_correction": "Min Correction (%)",
      "max_correction": "Max Correction (%)",
      "fuel_adder_afr": "Fuel Adder (AFR %)",
      "fuel_ve_comp": "Fuel VE Comp. (%)",
      "timing_retard": "Timing Retard (°)",
      "9888_red_light": "&#9888; RED LIGHT",
      "and_a_minimum_of": "and a minimum of",
      "timing_locked_in": "Timing Locked In!",
      "1_timeconstant": "1 / timeConstant",
      "throttle_pedal": "— Throttle pedal",
      "5_seconds_ago": "← 5 seconds ago",
      "live_telemetry": "LIVE TELEMETRY",
      "tps_90": "(TPS &gt; 90%)",
      "hold_to_engage": "Hold to Engage",
      "peak_boost": "PEAK BOOST: --",
      "ready_to_stage": "READY TO STAGE",
      "running_mode": "Running Mode",
      "push_to_start": "Push to Start",
      "undo_redo": "— Undo / Redo",
      "to_run_stock": "To run Stock:",
      "not_you": "! Not you? (",
      "firing_order": "FIRING ORDER",
      "deadband": "Deadband (%)",
      "you_must_be": "You must be",
      "simple_mode": "Simple Mode",
      "distributor": "DISTRIBUTOR",
      "n2o_active": "N2O: ACTIVE",
      "fuel_air": "Combustível & Ar",
      "vvt_cams": "VVT & Cames",
      "min_tps": "Min TPS (%)",
      "peak_hp": "PEAK HP: --",
      "peak_tq": "PEAK TQ: --",
      "clutch_slip": "CLUTCH SLIP",
      "clutch_fail": "CLUTCH FAIL",
      "vvl_vtec": "VVL / VTEC",
      "idle_mode": "Idle Mode",
      "ref_hp": "REF HP: --",
      "ref_tq": "REF TQ: --",
      "and_using": "and using",
      "decel_cut": "DECEL CUT",
      "ignition": "Ignição",
      "advanced": "Avançado",
      "wot_mode": "WOT Mode",
      "337_hp": "≈ 33.7 HP",
      "got_it": "Entendido! ✓",
      "idle_pid": "IDLE PID",
      "timeslip": "TIMESLIP",
      "psi": "-- PSI",
      "setup": "Configuração",
      "player": "Player",
      "click": "Click",
      "back": "← Voltar",
      "25s": "-2.5s",
      "for": "° for",
      "speed": "VELOC.",
      "accel": "ACEL.",
      "slip": "PATINOU!",
      "time": "TEMPO",
      "gear": "MARCHA",
      "mods": "Mods",
      "tdc": "PMS",
      "mph": "MPH",
      "mod_intake": "Admissão",
      "mod_intake_manifold": "Coletor de Admissão",
      "mod_exhaust_manifold": "Coletor de Escapamento",
      "mod_exhaust": "Escapamento",
      "mod_port_and_polish": "Port e Polimento",
      "mod_turbocharger": "Turbocompressor",
      "mod_supercharger": "Supercompressor",
      "mod_camshaft": "Eixo de Comando",
      "mod_pistons": "Pistões",
      "mod_rods": "Bielas",
      "mod_clutch": "Embreagem",
      "mod_intercooler": "Intercooler",
      "mod_fuel_pump": "Bomba de Combustível",
      "mod_fuel_injector": "Injetor de Combustível",
      "stock_none": "Original / Nenhum",
      "dry_shot_system": "Sistema Dry Shot",
      "wet_shot_system": "Sistema Wet Shot",
      "buy_nitrous_kit": "Comprar Kit de Nitro!",
      "mod_settings": "Configurações de Mods",
      "wastegate_spring_psi": "Mola da Wastegate (psi)",
      "wastegate_spring_kpa": "Mola da Wastegate (kPa)",
      "map_axes_scale_help": "Os eixos MAP escalam para 2× a pressão da mola.",
      "closed_loop_boost": "Boost de Malha Fechada",
      "pulley_ratio": "Relacão da Polia (SC/Eng)",
      "bypass_threshold": "Limite de Bypass (%)",
      "max_sc_rpm": "RPM Máximo SC:",
      "twin_turbo_setup": "Configuração Twin Turbo",
      "twin_turbo_help": "(×1.9 fluxo de ar, ~½× velocidade de spool)",
      "custom_transmission": "Transmissão Personalizada",
      "applied": "Applied!",
      "stop_engine": "STOP ENGINE",
      "flooded": "FLOODED",
      "no_start_trigger": "NO START: TRIGGER ANGLE",
      "no_start_lean": "NO START: LEAN",
      "stalled": "STALLED",
      "stalled_rpm": "STALLED: RPM dropped below cranking speed.",
      "stalled_battery": "STALLED: Battery voltage critically low (8 V).",
      "submitting": "Submitting...",
      "submitted": "Submitted!",
      "error_retry": "Error (Retry)"
    }
  }
};